import UserType from 'constants/user';
import HomeWaiting from 'containers/homeScreen/home_waiting';
import ProfileCustomer from 'containers/profile_customer';
import StylistProfile from 'containers/stylist_profile';
import { useAuth } from 'contexts/AuthContext';
import { isProductionServer } from '../firebase';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { RootState } from 'redux/store';
import { PATH } from './constant';
import { UserQuizStatus } from 'containers/quiz_manager';

export default function ProfileRoute({ component: Component, ...rest }) {
    const { currentUser } = useAuth();
    const user = useSelector((state: RootState) => state.userDetail.me);
    const approvedState = useSelector((state: RootState) => state.authentication.approved);
    const pendingQuizzes = useSelector((state: RootState) => state.userDetail.pendingQuizzes);
    const isPendingQuizzes =
        pendingQuizzes?.hasOwnProperty('getPendingQuizzes') &&
        pendingQuizzes?.getPendingQuizzes?.quizConfigs?.filter((item) => item.status === UserQuizStatus.pending)
            ?.length;

    const getProfileUser = (props) => {
        let { location } = props;
        if (user) {
            if (user.userType === UserType.Customer) {
                if (isPendingQuizzes === 0) {
                    return <ProfileCustomer />;
                } else {
                    return (
                        <Redirect
                            to={{
                                pathname: PATH.QUIZ_MANAGER,
                                state: { from: location },
                            }}
                        />
                    );
                }
            } else if ((false && user.userType === UserType.Stylist && isProductionServer) || !approvedState) {
                return <HomeWaiting />;
            } else {
                return <StylistProfile />;
            }
        }
    };

    return (
        <Route
            {...rest}
            render={(props) => {
                let { location } = props;

                return currentUser ? (
                    getProfileUser(props)
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: location },
                        }}
                    />
                );
            }}
        />
    );
}
